import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * External dependencies
 */
import { noop } from 'lodash';
/**
 * Internal dependencies
 */

import UnitControl from './unit-control';
import { LABELS, getAllValue, isValuesMixed, isValuesDefined } from './utils';
export default function AllInputControl(_ref) {
  var _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      _ref$onHoverOn = _ref.onHoverOn,
      onHoverOn = _ref$onHoverOn === void 0 ? noop : _ref$onHoverOn,
      _ref$onHoverOff = _ref.onHoverOff,
      onHoverOff = _ref$onHoverOff === void 0 ? noop : _ref$onHoverOff,
      values = _ref.values,
      props = _objectWithoutProperties(_ref, ["onChange", "onFocus", "onHoverOn", "onHoverOff", "values"]);

  var allValue = getAllValue(values);
  var hasValues = isValuesDefined(values);
  var isMixed = hasValues && isValuesMixed(values);
  var allPlaceholder = isMixed ? LABELS.mixed : null;

  var handleOnFocus = function handleOnFocus(event) {
    onFocus(event, {
      side: 'all'
    });
  };

  var handleOnChange = function handleOnChange(next) {
    var nextValues = _objectSpread({}, values);

    nextValues.top = next;
    nextValues.bottom = next;
    nextValues.left = next;
    nextValues.right = next;
    onChange(nextValues);
  };

  var handleOnHoverOn = function handleOnHoverOn() {
    onHoverOn({
      top: true,
      bottom: true,
      left: true,
      right: true
    });
  };

  var handleOnHoverOff = function handleOnHoverOff() {
    onHoverOff({
      top: false,
      bottom: false,
      left: false,
      right: false
    });
  };

  return createElement(UnitControl, _extends({}, props, {
    disableUnits: isMixed,
    isOnly: true,
    value: allValue,
    onChange: handleOnChange,
    onFocus: handleOnFocus,
    onHoverOn: handleOnHoverOn,
    onHoverOff: handleOnHoverOff,
    placeholder: allPlaceholder
  }));
}
//# sourceMappingURL=all-input-control.js.map